import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotCheck = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotCheck"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="m65.22 17.55-9.8-9.8-3.34 3.34a28.92 28.92 0 0 0-17.9-6.18c-16.05 0-29.11 13.06-29.11 29.11s13.06 29.11 29.11 29.11 29.11-13.06 29.11-29.11c0-4.26-.93-8.3-2.58-11.95l4.51-4.51z"
      />
      <path
        fill="#27DBA8"
        d="m32.36 47.57-16.1-16.1 6.97-6.98 9.13 9.14 23.06-23.06 6.97 6.97z"
      />
      <path
        fill="#fff"
        d="M32.36 47.57 16.25 31.46l6.97-6.97 9.14 9.13 19.85-19.85A27.02 27.02 0 0 0 34.18 6.9C19.21 6.9 7.07 19.04 7.07 34.01s12.14 27.11 27.11 27.11 27.11-12.14 27.11-27.11c0-4.46-1.08-8.66-2.99-12.37L32.37 47.57z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="m63.1 17.55-7.68-7.68-3.25 3.24c-4.84-4.17-11.12-6.7-18-6.7-15.22 0-27.61 12.38-27.61 27.61s12.38 27.61 27.61 27.61 27.61-12.38 27.61-27.61c0-4.4-1.05-8.56-2.89-12.26zm-1.42 0L32.36 46.87l-15.4-15.4 6.26-6.26 9.14 9.13 23.06-23.05zm-.9 16.46c0 14.67-11.94 26.61-26.61 26.61S7.57 48.68 7.57 34.01s11.93-26.6 26.6-26.6c6.6 0 12.63 2.42 17.29 6.41l-19.1 19.1-9.14-9.13-7.68 7.68 16.81 16.81L58.13 22.5c1.68 3.49 2.64 7.39 2.64 11.51z"
      />
    </svg>
  );
};
export default IllustrationSpotCheck;
